// Import all icon SVGs into the build
function requireAll(r) {
    r.keys().forEach(r);
}

const requireIcons = requireAll(
    require.context('../files/images/icons', true, /\.svg$/)
);

export default requireIcons;
